import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../utils/images";
import "../Styles/contact.css";
import { country_data } from "../utils/countryCodes";
import axios from "axios";

const ContactForm = () => {
  // API URL - use environment variable or default to localhost for development
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081';
  
  // Log the API URL being used for debugging
  console.log('ContactForm using API URL:', API_URL);
  
  const [countryEmoji, setCountryEmoji] = useState("🇮🇳");
  const [countryCode, setcountryCode] = useState("+91");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    course: "",
    message: "",
    agreedToPrivacyPolicy: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleCheckboxChange = (e) => {
    setPrivacyPolicy(e.target.checked);
    setFormData({ ...formData, agreedToPrivacyPolicy: e.target.checked });
  };
  
  const handleCountry = (code, emoji) => {
    setCountryEmoji(emoji);
    setcountryCode(code);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name || !formData.email || !formData.mobile || !formData.message) {
      setError("Please fill in all required fields");
      return;
    }
    
    if (!formData.agreedToPrivacyPolicy) {
      setError("You must agree to the privacy policy");
      return;
    }
    
    // Format the mobile number with country code
    const formattedMobile = `${countryCode} ${formData.mobile}`;
    
    // Prepare data for API
    const contactData = {
      name: formData.name,
      email: formData.email,
      mobile: formattedMobile,
      course: formData.course || "Not specified",
      message: formData.message,
      agreedToPrivacyPolicy: formData.agreedToPrivacyPolicy
    };
    
    setLoading(true);
    setError(null);
    
    try {
      console.log('Submitting contact data to API:', `${API_URL}/api/contact`, contactData);
      
      // Send data to backend API with proper headers and CORS configuration
      const response = await axios.post(`${API_URL}/api/contact`, contactData, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      });
      
      // Show success message
      setSuccess(true);
      
      // Reset form
      setFormData({
        name: "",
        email: "",
        mobile: "",
        course: "",
        message: "",
        agreedToPrivacyPolicy: false
      });
      setPrivacyPolicy(false);
      
      // Clear success message after 5 seconds
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
      
    } catch (err) {
      console.error("Error submitting contact form:", err);
      setError(err.response?.data?.error || "Failed to submit form. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="contact-section">
      <div className="contact-left">
        <div className="get-in-touch">
          <h4 className="get-in-touch-heading">Get in Touch</h4>
          <h1 className="get-in-touch-title">Let’s chat. Reach out to us.</h1>
          <p className="get-in-touch-content">
            Have questions or feedback? We’re here to help. Send us a message,
            and we’ll respond within 24 Hours
          </p>
        </div>
        <hr className="line" />
        <div className="contact-input">
          {/* Success Message */}
          {success && (
            <div className="success-message">
              <p>Thank you for contacting us! We'll get back to you soon.</p>
            </div>
          )}
          
          {/* Error Message */}
          {error && (
            <div className="error-message">
              <p>{error}</p>
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="form">
            <div className="form-grid">
              <input
                id="input"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Your Name *"
                onClick={stopPropagation}
                required
              />

              <input
                id="input"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Your Email *"
                onClick={stopPropagation}
                required
              />

              <div className="phonenumber-field">
                <div className="country-container">
                  <span className="country-text">{countryEmoji}</span>
                  <select
                    className="country-dropdown"
                    name="country-selector"
                    onChange={(e)=>handleCountry(JSON.parse(e.target.value).code,JSON.parse(e.target.value).flag)}
                  >
                    <option value="🇮🇳">{countryCode}</option>
                    {country_data.map((item) => (
                      <option key={item.code} value={JSON.stringify({"flag":item.flag,"code":item.dial_code})}>{item.dial_code}</option>
                    ))}
                  </select>
                </div>
                <input
                  id="input-phone"
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter Your mobile number *"
                  onClick={stopPropagation}
                  required
                />
              </div>

              <input
                id="input"
                type="text"
                name="course"
                value={formData.course}
                onChange={handleChange}
                placeholder="Course"
                onClick={stopPropagation}
              />

              <textarea
                id="input"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write Message *"
                onClick={stopPropagation}
                required
              ></textarea>

              <div className="check">
                <input
                  type="checkbox"
                  id="Accept_Privacy"
                  name="Privacy"
                  checked={privacyPolicy}
                  onChange={handleCheckboxChange}
                  required
                />
                <p className="check-text">
                  I agree to our{" "}
                  <Link className="privacy"> privacy policy </Link>
                </p>
              </div>

              <button
                type="submit"
                onClick={(e) => e.stopPropagation()}
                className="request-submit-btn"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="contact-rigth">
        <div className="contact-rigth-image">
          <img src={IMAGES.CONTACT_MAIN} alt="img" />
        </div>
        <div className="contact-right-image-bottom">
          <div className="contact-mail-part">
            <img src={IMAGES.MAIL_ICON} alt="mail-icon" />
            <div className="contact-mail-overall">
              <h1 className="contact-mail-heading">Email</h1>
              <p className="contact-mail-content">srimworks@gmail.com</p>
            </div>
          </div>
          <div className="contact-mail-part">
            <img src={IMAGES.CALL_ICON} alt="phone-icon" />
            <div className="contact-mail-overall">
              <h1 className="contact-mail-heading">Phone</h1>
              <p className="contact-mail-content">+91 (080) 6218-0277</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
